import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    FETCH_CARD_ISSUED_COUNT,
    FETCH_CARD_ISSUED_COUNTS,
    REMOVE_CARD_ISSUED_COUNTS
} from './types';

const notifyError = (error, fallback) => {
    NotificationManager.error(error.response?.data?.msg || fallback);
};

export const fetchCardIssuedCounts = filter => dispatch => api
    .get('/card-issued-counts', { params: filter })
    .then(response => {
        dispatch({ type: FETCH_CARD_ISSUED_COUNTS, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải danh sách thẻ đã phát.');
        return Promise.reject(error);
    });

export const fetchCardIssuedCount = id => dispatch => api
    .get(`/card-issued-counts/${id}`)
    .then(response => {
        dispatch({ type: FETCH_CARD_ISSUED_COUNT, payload: response.data.data });
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải chi tiết thẻ đã phát.');
        return Promise.reject(error);
    });

export const createCardIssuedCount = data => () => api
    .post('/card-issued-counts', data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể thêm thẻ đã phát.');
        return Promise.reject(error);
    });

export const updateCardIssuedCount = (id, data) => () => api
    .put(`/card-issued-counts/${id}`, data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể cập nhật thẻ đã phát.');
        return Promise.reject(error);
    });

export const removeCardIssuedCounts = ids => dispatch => api
    .delete('/card-issued-counts', { data: { ids } })
    .then(response => {
        dispatch({ type: REMOVE_CARD_ISSUED_COUNTS, payload: ids });
        NotificationManager.success(response.data.msg);
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể xóa thẻ đã phát.');
        return Promise.reject(error);
    });
